import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { Scalars, useSeparateInvoiceMutation } from "../../../graphql/generated";
import useDialog from "../../../utils/hooks/useDialog";
import InvoiceSeparationModal, {
  InvoiceSeparationModalProps,
} from "./InvoiceSeparationModal";

type InvoiceSeparationModalContainerProps = Omit<
  InvoiceSeparationModalProps,
  "onSubmit" | "isLoading"
> & {
  invoiceId: Scalars["ObjectId"];
  onSeparated: () => void;
};

const InvoiceSeparationModalContainer: React.FC<
  InvoiceSeparationModalContainerProps
> = ({ invoiceId, onSeparated, onClose, ...restProps }) => {
  const { t } = useTranslation(["finance", "common"]);
  const { enqueueSnackbar } = useSnackbar();
  const { showDialog } = useDialog();
  const separateInvoiceMutation = useSeparateInvoiceMutation();

  return (
    <InvoiceSeparationModal
      {...restProps}
      onClose={onClose}
      isLoading={separateInvoiceMutation.isLoading}
      onSubmit={async (shipmentIds) => {
        try {
          await separateInvoiceMutation.mutateAsync({
            invoiceId,
            shipmentIds,
          });
          enqueueSnackbar(
            t("separateInvoiceSuccess", "Orders successfully separated"),
            {
              variant: "success",
            }
          );
          onClose();
          onSeparated();
        } catch (e) {
          console.error(e);
          showDialog({
            type: "error",
            title: t("error.separateInvoiceError", "Error separating orders"),
            description:
              (e as Error).message ||
              t("common:error.unknownError", "Unknown error"),
          });
        }
      }}
    />
  );
};

export default InvoiceSeparationModalContainer;
